<template>
  <div class="search-container navbar-text">
    <label @click="toggleForm">
      <i class="icon-search"></i>
    </label>
    <div :class="formClass" v-if="show">
      <div class="container">
        <div class="form-wrapper">
          <label>
            <i class="icon-search"></i>
          </label>
          <form class="form-inline">
            <input
              type="text"
              name="search"
              autocomplete="off"
              class="form-control"
              :placeholder="$t('app.searchPlaceholder')"
              @input="search"
              @click="resetSelectedResult"
              @keydown.enter.prevent="onEnter"
              @keyup.down="onDown"
              @keyup.up="onUp"
              v-model="query"
              ref="input">
          </form>
          <label @click="toggleForm">
            <i class="icon-close"></i>
          </label>
        </div>
        <header-search-results v-if="results && results.length" :results="results" :query="query" :selectedResult="selectedResult"></header-search-results>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import Xhr from '@Core/xhr'
import throttle from 'lodash/throttle'
import HeaderSearchResults from './HeaderSearchResults.vue'

export default {
  components: {
    HeaderSearchResults
  },

  props: {
    src: {
      default: '/search'
    }
  },

  data () {
    return {
      show: false,
      query: null,
      results: null,
      selectedResult: null
    }
  },

  computed: {
    formClass () {
      return 'search-form' + (this.show ? ' show' : '')
    }
  },

  created () {
    this.query = this.getQueryString()
  },

  methods: {
    getQueryString () {
      let params = qs.parse(location.search.replace('?', ''))
      return (params.query && params.query.length) ? params.query : null
    },

    toggleForm () {
      this.show = !this.show

      // Focus field if shown else clear results
      if (this.show) {
        Vue.nextTick(() => this.$refs.input.focus())
      } else {
        this.results = null
        this.query = this.getQueryString()
      }
    },

    search: throttle(async function () {
      this.resetSelectedResult()

      this.results = this.query.length >= 2
        ? await this.getResults()
        : null
    }, 1000),

    getResults () {
      return new Xhr({ query: this.query }).post(this.src)
    },

    resetSelectedResult () {
      this.selectedResult = null
    },

    onEnter () {
      if (this.selectedResult === null) {
        window.location = window.App.url + '/'+App.vue.$options.lang.$t('routes.category')+'?page=1&query=' + this.query
      } else {
        if (this.selectedResult > (this.results[0].results.length + this.results[1].results.length - 1)) {
          window.location = window.App.url + this.results[2].results[this.selectedResult - this.results[1].results.length - this.results[0].results.length].link
        }
        else if (this.selectedResult > (this.results[0].results.length - 1)) {
          window.location = window.App.url + this.results[1].results[this.selectedResult - this.results[0].results.length].link
        } else {
          window.location = window.App.url + this.results[0].results[this.selectedResult].link
        }
      }
    },

    onDown () {
      if (((this.results[0].results.length + this.results[1].results.length + this.results[2].results.length) - 1 > this.selectedResult) || this.selectedResult === null) {        this.selectedResult = this.selectedResult === null
          ? 0
          : this.selectedResult + 1
      }
    },

    onUp () {
      if (this.selectedResult !== null) {
        this.selectedResult = this.selectedResult === 0
          ? null
          : this.selectedResult - 1
      }
    }
  }
}
</script>
